import SolutionCenter from './SolutionCenter';

export default SolutionCenter;
